<script lang="ts">
  // The mockup's list toolbar: optional search box, arbitrary filter chips/
  // dropdowns (left, via a snippet — they vary too much per page to model
  // generically), a spacer, and a right-aligned actions snippet (the primary
  // "+ New ..." button, bulk-selection controls, etc.).
  import { Search } from 'lucide-svelte';
  import type { Snippet } from 'svelte';

  const {
    searchValue = '',
    searchPlaceholder = 'Search',
    searchLabel = searchPlaceholder,
    onSearch,
    filters,
    actions
  }: {
    searchValue?: string;
    searchPlaceholder?: string;
    searchLabel?: string;
    onSearch?: (value: string) => void;
    filters?: Snippet;
    actions?: Snippet;
  } = $props();
</script>

<div class="mb-3 flex flex-wrap items-center gap-2">
  {#if onSearch}
    <!-- Full width on a phone, fixed 240px from `sm` up: sharing one narrow
         row with a long "+ New ..." label crushed the field to a few
         characters. -->
    <label class="relative flex min-w-0 flex-[1_1_100%] items-center sm:flex-[0_1_240px]">
      <span class="sr-only">{searchLabel}</span>
      <Search class="pointer-events-none absolute left-2.5 h-[15px] w-[15px] text-dark-gray" />
      <input
        type="search"
        class="input min-h-[34px] py-1.5 pl-8 text-[12.5px]"
        placeholder={searchPlaceholder}
        value={searchValue}
        oninput={(e) => onSearch(e.currentTarget.value)}
      />
    </label>
  {/if}
  {#if filters}
    {@render filters()}
  {/if}
  <span class="hidden flex-1 sm:block"></span>
  {#if actions}
    {@render actions()}
  {/if}
</div>
